module.exports = __webpack_public_path__ + "img/kz.aebe1ef.svg";